import {
  setCheckButtons,
  setTableButtons,
  getStepFormBottomButtons
} from '@/utils/getbuttons.js'
import {
  getSameAttribute,
  getLevelArray,
  resetAttribute
} from '@/utils/handleData.js'
import { daysFormat, getStringTime } from '@/filters/index'
const useDetails = {
  name: 'useDetails',
  title: '安全经费使用明细列表',
  saveFun: (params) => {
    return params.pageStatus === 'detailNum'
      ? 'safetyInput/addSafetyUseDetails'
      : ''
  },
  getParentFun: (params) => {
    return params.pageStatus === 'detailNum'
      ? 'safetyInput/getSafetyUseAccount'
      : ''
  },
  tagInfo: (params) => {
    const amount = params.state.safetyInput.currentAccount.useAmount
    return (
      '当前添加的安全经费使用明细合计金额应等于与其对应使用台帐总使用金额' +
      (amount ? amount : 0) +
      '元。当不相等时数值为红色，请全部分配后再提交。'
    )
  },
  showSummary: true,
  rowData: (params) => {
    return params.getters['safetyInput/compileUseDetail']
  },
  columns: [
    {
      prop: 'securityFundType',
      label: '\xa0\xa0安全经费类型',
      align: 'left',
      bgcolor: true,
      width: '600px'
    },
    {
      prop: 'expenseAmount',
      label: '使用金额(元)',
      unShow0: true,
      formItem: {
        type: 'input',
        readonly: (params) => {
          return params.pageStatus === 'check' ? true : false
        }
      },
      tooltip: {
        tipValue: (params) => {
          const amount = params.state.safetyInput.currentAccount.useAmount
          const useDetails = params.state.safetyInput.currentAccount.useDetails
          const totolDetail = getSameAttribute(
            useDetails ? useDetails : [],
            'expenseAmount'
          ).addValue
          const difference = amount - totolDetail
          return difference
        },
        tipLabel: '剩余分配金额：'
      },
      isIdeal: () => {
        return (row, column) => {
          return column.tooltip && column.tooltip.tipValue === 0 ? true : false
        }
      }
    }
  ],
  hasFooter: (params) => {
    return !params.state.safetyInput.currentAccount.isMeasured
  }
}
const deviations = {
  name: 'deviations',
  width: '60%',
  title: '资金使用偏差分析列表',
  saveFun: (params) => {
    return params.pageStatus === 'add'
      ? 'safetyInput/addSafetyCheckDetails'
      : params.pageStatus === 'edit'
      ? 'safetyInput/editSafetyCheckDetails'
      : ''
  },
  getParentFun: (params) => {
    return params.pageStatus === 'add' || params.pageStatus === 'edit'
      ? 'safetyInput/getSafetyUseCheck'
      : ''
  },
  tagInfo: (params) => {
    return (
      '当前安全资金使用偏差分析数据截止日期为' +
      params.state.safetyInput.endMonth +
      '。不显示偏差为0的资金类型，累计偏差超过10万元需要分析填写偏差原因。'
    )
  },
  showSummary: true,
  detailPage: [
    {
      codes: ['deviation'],
      type: 'expand',
      name: 'deviations'
    }
  ],
  rowData: (params) => {
    const deviations = params.getters['safetyInput/safetyUseList'].filter(
      (item) => {
        item.children = item.children.filter((child) => {
          return Math.abs(child.deviation) > 0
        })
        return Math.abs(item.deviation) > 0
      }
    )
    return deviations
  },
  columns: [
    {
      prop: 'securityFundType',
      label: '\xa0\xa0安全经费类型',
      align: 'left',
      bgcolor: true,
      width: '550px'
    },
    {
      prop: 'deviation',
      label: '使用节余情况(万元)',
      drillDown: true
    },
    {
      prop: 'deviationReason',
      label: '\xa0\xa0\xa0\xa0\xa0\xa0偏差情况及原因',
      formItem: {
        type: 'input',
        placeholder: (params) => {
          return params.pageStatus === 'check'
            ? ''
            : '偏差大于10万时请输入分析原因'
        },
        inputType: 'textarea',
        autosize: { minRows: 2 },
        readonly: (params) => {
          return params.pageStatus === 'check' ? true : false
        }
      },
      width: '430px',
      overflow: false
    }
  ],
  hasFooter: (params) => {
    return params.pageStatus === 'check' ? false : true
  }
}
const violations = {
  name: 'violations',
  width: '75%',
  title: '安全经费使用违规登记列表',
  saveFun: (params) => {
    return params.pageStatus === 'add' || params.pageStatus === 'edit'
      ? 'safetyInput/addSafetyViolations'
      : ''
  },
  deleteFun: 'safetyInput/deleteSafetyViolations',
  getParentFun: (params) => {
    return params.pageStatus === 'add' || params.pageStatus === 'edit'
      ? 'safetyInput/getSafetyUseCheck'
      : ''
  },
  detailPage: [
    {
      buttonName: '物资验收单编号',
      type: 'drawerTable',
      name: 'goodsInbound',
      checkType: 'checkByRow',
      checkFun: 'material/getGoodsList',
      pageStatus: 'check'
    },
    {
      buttonName: '发票图片',
      type: 'preview'
    },
    {
      buttonName: '其他附件',
      type: 'preview'
    }
  ],
  headButtons: (params) => {
    return params.pageStatus !== 'check' ? setCheckButtons(['新增']) : ''
  },
  expandColumn: true,
  tagInfo:
    '当前列表可选择数据截止时间前状态为“未核查”的使用台帐信息选择核查，核查信息如有违规项目请输入违规类型、违规金额及违规说明。',
  rowData: (params) => {
    return params.state.safetyInput.violations
  },
  columns: (params) => {
    var columns = [
      {
        prop: 'account',
        label: '使用台帐',
        width: '460px',
        formItem: {
          type: 'select',
          options: (params) => {
            const safetyUseAccount =
              params.state.safetyInput.safetyUseAccount.filter((item) => {
                return (
                  (params.pageStatus === 'check' ||
                    (params.pageStatus !== 'check' &&
                      item.checkStatus !== '已核查')) &&
                  new Date(item.useDate).getTime <=
                    new Date(params.state.safetyInput.endMonth).getTime
                )
              })
            safetyUseAccount.forEach((item) => {
              item.value = item.uid
              item.label =
                item.useDate + '\xa0' + item.useReason + item.useAmount + '元'
            })
            return safetyUseAccount
          },
          placeholder: '请选择要核查使用台帐，展开可查看使用详情信息',
          valueKey: 'uid',
          disabled: (params) => {
            return params.pageStatus === 'check' ? true : false
          },
          clearable: true
        }
      },
      {
        prop: 'violationName',
        label: '违规类型名称',
        formItem: {
          type: 'select',
          options: [
            { value: '1', label: '发票缺失' },
            { value: '2', label: '非安全经费范畴' },
            { value: '3', label: '实际未投入' },
            { value: '4', label: '没有物资采购明细' }
          ],
          placeholder: '请输入或选择',
          filterable: true,
          create: true,
          clearable: true,
          disabled: (params) => {
            return params.pageStatus === 'check' ? true : false
          }
        }
      },
      {
        prop: 'violationAmount',
        label: '违规金额(元)',
        formItem: {
          type: 'input',
          readonly: (params) => {
            return params.pageStatus === 'check' ? true : false
          }
        },
        width: '120px',
        isIdeal: () => {
          return (row) => {
            return row.account &&
              row.violationAmount <= row.account.useAmount &&
              row.violationAmount > 0
              ? true
              : false
          }
        }
      },
      {
        prop: 'violationExplain',
        label: '违规说明',
        formItem: {
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 2 },
          clearable: true
        },
        overflow: false
      },
      {
        prop: 'isCorrect',
        label: '是否整改',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.dictionarys.trueFalse
          },
          checkByValue: true,
          clearable: true
        },
        width: '100px'
      },
      {
        prop: 'correctExplain',
        label: '整改说明',
        formItem: {
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 2 },
          clearable: true
        },
        overflow: false
      }
    ]
    if (params.pageStatus !== 'check') {
      columns.push({
        label: '操作',
        buttons: setTableButtons(['删除']),
        width: '100px'
      })
    }
    return columns
  },
  hasFooter: (params) => {
    return params.state.safetyInput.violations.length ? true : false
  }
}
const goodsOutbound = {
  name: 'goodsOutbound',
  title: '安全物资领用明细列表',
  size: '70%',
  direction: 'btt',
  maxheight: '450px',
  getParentFun: 'material/getGoodsList',
  getListFun: 'material/getGoodsOutbound',
  deleteFun: (params) => {
    return params.pageStatus === 'edit' ? 'material/deleteGoodsOutbound' : null
  },
  detailPage: [
    {
      buttonNames: ['生成领用单', '编辑领用单'],
      name: 'useReport',
      type: 'dialogForm',
      pageStatus: (params) => {
        return params.pageStatus === 'generate' ? 'add' : 'edit'
      }
    }
  ],
  headButtons: (params) => {
    return params.pageStatus === 'generate'
      ? setCheckButtons(['生成领用单'])
      : params.pageStatus === 'edit'
      ? setCheckButtons(['更新领用明细', '编辑领用单'])
      : null
  },
  tagInfo: (params) => {
    const useAmount = getSameAttribute(
      params.state.material.goodsOutbound,
      'useAmount'
    ).addValue
    return params.pageStatus === 'generate'
      ? '当前列表共' +
          params.getters['material/compileOutbound'].length +
          '种物资出库，出库数量默认为选择入库数据对应的理论库存数量，合计出库金额为：' +
          useAmount +
          '元，带“*”列数据必填，请修改完善并确认后再生成物资领用单；点击“分批”按钮可以拆分数据分不同保管人或用途登记领用'
      : '当前列表为编号' +
          params.state.material.curUseReport.useReportNo +
          '的物资领用单；合计出库金额为：' +
          useAmount +
          '元。'
  },
  rowData: (params) => {
    return params.getters['material/compileOutbound']
  },
  columns: (params) => {
    var columns = [
      {
        prop: 'label',
        label: '\xa0\xa0物资编号/名称&&入库日期',
        width: '300px',
        align: 'left'
      },
      {
        prop: 'model',
        label: '规格型号'
      },
      {
        prop: 'goodsType',
        label: '物资类型',
        formItem: {
          type: 'cascader',
          options: params.state.dictionarys.goodsType.filter((item) => {
            return item.label === '安全物资'
          }),
          showAllLevels: false,
          disabled: true
        }
      },
      {
        prop: 'unit',
        label: '单位'
      },
      {
        prop: 'price',
        label: '单价(元)'
      },
      {
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      {
        prop: 'totalUsed',
        label: '已领用数量'
      },
      {
        prop: 'useQuantity',
        label: '*出库数量',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'input'
                }
              : null
          }
        },
        number: true,
        isIdeal: () => {
          return (row) => {
            return row.useQuantity > row.inboundQuantity - row.totalUsed
              ? false
              : true
          }
        }
      },
      {
        prop: 'useAmount',
        label: '出库金额(元)',
        width: '120px'
      },
      {
        prop: 'keeper',
        label: '现场保管人',
        width: '120px',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'select',
                  options: (params) => {
                    return params.state.contractor.managePersonNames
                  },
                  filterable: true,
                  create: true,
                  placeholder:
                    row.goodsType[1] === '安全标志标牌' ? '该项必填' : ''
                }
              : null
          }
        }
      },
      {
        prop: 'purpose',
        label: '用途',
        formItem: (params) => {
          return (row) => {
            return !row.children && params.pageStatus !== 'check'
              ? {
                  type: 'input',
                  placeholder:
                    row.goodsType[0] === '危险化学品' ? '该项必填' : ''
                }
              : null
          }
        },
        width: '260px'
      }
    ]
    if (params.pageStatus !== 'check') {
      columns.push({
        label: '操作',
        buttons: (params) => {
          return (row) => {
            return !row.children
              ? params.pageStatus === 'edit'
                ? setTableButtons(['删除'])
                : setTableButtons(['分批', '删除'])
              : null
          }
        },
        width: '160px'
      })
    }
    return columns
  }
}
const useReport = {
  name: 'useReport',
  title: (params) => {
    return params.pageStatus === 'add' ? '新增物资领用单' : '编辑物资领用单'
  },
  manualUpload: true,
  addFun: 'material/addUseReport',
  editFun: 'material/editUseReport',
  getParentFun: 'material/getUseReport',
  formParams: {
    uid: '',
    orgUid: (params) => {
      return params.orgValue
    },
    useAmount: (params) => {
      return getSameAttribute(params.state.material.goodsOutbound, 'useAmount')
        .addValue
    },
    useReportNo: () => {
      return 'LYD' + getStringTime(new Date())
    },
    grantPerson: '',
    usePerson: '',
    useDepartment: '',
    useDate: daysFormat(new Date()),
    usePosition: '',
    usePhotos: [],
    useDetails: (params) => {
      return params.state.material.goodsOutbound
    },
    fileLists: {
      usePhotos: []
    }
  },
  formRules: {
    grantPerson: [
      {
        required: true,
        message: '请输入或选择发放人',
        trigger: 'change'
      }
    ],
    usePerson: [
      {
        required: true,
        message: '请输入或选择领用人',
        trigger: 'change'
      }
    ],
    useDepartment: [
      {
        required: true,
        message: '请输入或选择领用部门',
        trigger: 'change'
      }
    ],
    usePosition: [
      {
        required: true,
        message: '请选择使用部位',
        trigger: 'change'
      }
    ]
  },
  formData: [
    {
      key: 'useReportNo',
      label: '领用单编号',
      type: 'input',
      readonly: true
    },
    {
      key: 'useAmount',
      label: '出库总金额',
      type: 'input',
      readonly: true,
      inputButton: '元'
    },
    {
      key: 'grantPerson',
      label: '发放人',
      type: 'select',
      options: (params) => {
        return params.state.contractor.managePersonNames
      },
      filterable: true,
      create: true
    },
    {
      key: 'usePerson',
      label: '领用人',
      type: 'select',
      options: (params) => {
        return params.state.contractor.managePersonNames
      },
      filterable: true,
      create: true
    },
    {
      key: 'useDepartment',
      label: '使用部门',
      type: 'select',
      options: (params) => {
        return params.orgFields.department && params.orgFields.department[0]
          ? params.orgFields.department[0].children
          : []
      },
      filterable: true,
      create: true
    },
    {
      key: 'usePosition',
      label: '使用部位',
      type: 'cascader',
      options: (params) => {
        return params.state.division.subitemList
      },
      placeholder: '可任选一个级别选项',
      filterable: true,
      checkStrictly: true,
      showAllLevels: false,
      emitPath: false
    },
    {
      key: 'usePhotos',
      label: '其他附件',
      type: 'upload',
      autoUpload: false,
      limit: 4,
      span: 24
    }
  ]
}
const goodsInbound = {
  name: 'goodsInbound',
  title: '安全物资验收单明细列表',
  size: '70%',
  getParentFun: (params) => {
    return params.step === 'safetyGoodsList' ? 'material/getGoodsList' : null
  },
  detailPage: [
    {
      codes: ['generate', 'edit'],
      name: 'safetyUseAccount',
      type: 'stepForm',
      step: 'safetyUseAccountInfo',
      theme: 'safetyInput',
      label: '生成物资验收单',
      pageStatus: (params) => {
        return params.pageStatus === 'generate'
          ? 'add'
          : params.pageStatus === 'edit'
          ? 'edit'
          : 'check'
      }
    }
  ],
  maxheight: (params) => {
    return params.pageStatus === 'check' ? '530px' : '460px'
  },
  headButtons: (params) => {
    return params.pageStatus === 'generate'
      ? setCheckButtons(['生成验收单'])
      : params.pageStatus === 'edit'
      ? setCheckButtons(['更新验收明细', '编辑验收单'])
      : null
  },
  tagInfo: (params) => {
    const inboundAmount = getSameAttribute(
      params.state.material.goodsInbound,
      'inboundAmount'
    ).addValue
    const isZero = params.state.material.goodsInbound.filter((item) => {
      return !item.price
    })
    return params.state.material.goodsInbound[0]
      ? '当前列表为' +
          params.state.material.goodsInbound[0].supplier +
          (params.pageStatus === 'generate'
            ? '物资入库明细；合计入库金额为：' +
              inboundAmount +
              '元，其中' +
              isZero.length +
              '条单价为0元，请修改完善并确认后再生成物资验收单'
            : '的入库明细已经生成物资验收单，编号为' +
              params.state.material.goodsInbound[0].checkReportNo +
              '；合计入库金额为：' +
              inboundAmount +
              '元。')
      : ''
  },
  rowData: (params) => {
    return params.state.material.goodsInbound
  },
  columns: (params) => {
    var columns = [
      {
        prop: 'goods',
        label: '物资编号/名称',
        width: '300px'
      },
      {
        prop: 'model',
        label: '规格型号'
      },
      {
        prop: 'goodsType',
        label: '物资类型',
        formItem: {
          type: 'cascader',
          options: params.state.dictionarys.goodsType.filter((item) => {
            return item.label === '安全物资'
          }),
          showAllLevels: false,
          disabled: true
        }
      },
      {
        prop: 'unit',
        label: '单位'
      },
      {
        prop: 'price',
        label: '*单价(元)',
        formItem: {
          type: 'input',
          readonly: params.pageStatus === 'check' ? true : false
        },
        number: 2,
        isIdeal: () => {
          return (row, column) => {
            return row[column.prop] ? true : false
          }
        }
      },
      {
        prop: 'checkQuantity',
        label: '验收数量'
      },
      {
        prop: 'unqualified',
        label: '不合格品数量'
      },
      {
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      {
        prop: 'inboundAmount',
        label: '入库金额(元)',
        number: true
      }
    ]
    if (
      params.pageStatus === 'generate' ||
      (params.pageStatus === 'edit' &&
        !params.state.safetyInput.currentAccount.isMeasured)
    ) {
      columns.push(
        {
          prop: 'fundTypes',
          label: '*资金类型',
          formItem: {
            type: 'cascader',
            options: resetAttribute(
              params.state.safetyInput.securityFundType,
              'securityFundType',
              'uid'
            ),
            showAllLevels: false,
            disabled: params.pageStatus === 'check' ? true : false
          },
          width: '300px'
        },
        {
          label: '操作',
          buttons: setTableButtons(['删除']),
          width: '100px'
        }
      )
    }
    return columns
  }
}
const safetyInput = {
  pageTabs: [
    {
      label: '安全经费使用',
      theme: 'safetyInput',
      step: 'safetyUseList',
      stepLabel: '安全经费使用列表',
      checkFun: 'safetyInput/getSafetyUseList'
    },
    {
      label: '安全物资管理',
      theme: 'safetyInput',
      step: 'safetyGoodsList',
      stepLabel: '安全物资出入库统计列表',
      checkFun: 'material/getGoodsList'
    },
    {
      label: '安全经费计量',
      theme: 'safetyInput',
      step: 'safetyMeasureList',
      stepLabel: '安全经费计量列表',
      checkFun: 'measure/getSafetyMeasureList'
    }
  ],
  safetyMeasure: {
    name: 'safetyMeasure',
    theme: '安全经费计量',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    headButtons: setCheckButtons(['新增']),
    getListFun: 'measure/getSafetyMeasureList',
    addFun: 'measure/addMeasure',
    deleteFun: 'measure/deleteMeasure',
    getDetailFun: 'measure/getSafetyMeasureDetail',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      measurePeriod: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true,
        clearable: false
      },
      {
        key: 'measurePeriod',
        label: '计量期数',
        type: 'select',
        options: (params) => {
          const measure = params.state.measure.measureList[0]
          return measure ? measure.measure : []
        },
        checkByValue: true
      }
    ],
    detailPage: [
      {
        codes: ['add'],
        type: 'dialogForm',
        name: 'safetyMeasure'
      },
      {
        buttonName: '明细',
        type: 'tables',
        name: 'measureStatistics',
        checkType: 'checkByRow',
        checkFun: 'measure/getSafetyMeasureDetail',
        step: 'measureStatisticsList',
        theme: 'safetyInput',
        label: () => {
          return (params) => {
            return params.row ? params.row.period + '安全经费计量明细统计' : ''
          }
        },
        pageStatus: (params) => {
          return params.currentRow ? params.currentRow.measureState : 6
        }
      }
    ],
    tagInfo: (params) => {
      const measure = params.state.measure.measureList[0]
      const safetyFund =
        measure && measure.contractualSafetyFunds
          ? measure.contractualSafetyFunds
          : 0
      const cumulativeMeasure =
        measure && measure.cumulativeMeasure ? measure.cumulativeMeasure : 0
      return (
        '根据施工合同工程量清单安全生产费用为' +
        safetyFund +
        '元；截止当前共计计量' +
        (measure && measure.measure ? measure.measure.length : 0) +
        '期次，截止最后一期末已累计计量' +
        cumulativeMeasure +
        '元。'
      )
    },
    rowData: (params) => {
      const measure = params.state.measure.measureList[0]
      return measure ? measure.measure : []
    },
    columns: [
      {
        prop: 'period',
        label: '计量期数'
      },
      {
        prop: 'status',
        label: '计量状态',
        tag: (params) => {
          return params.dictionarys.measureState
        }
      },
      {
        prop: 'declaredAmount',
        label: '申报金额'
      },
      {
        prop: 'amountReviewedByResident',
        label: '驻地办审核金额'
      },
      {
        prop: 'amountReviewedByDirector',
        label: '总监办审核金额'
      },
      {
        prop: 'amountReviewedByProject',
        label: '项目办（公司）审核金额'
      },
      { prop: 'declaredDate', label: '申报日期' },
      { prop: 'measureDate', label: '计量完成日期' },
      {
        label: '操作',
        buttons: setTableButtons(['明细', '删除'])
      }
    ],
    hasPagination: false,
    safetyMeasure: {
      dialogTitle: '新增计量期次',
      addFun: 'measure/addMeasure',
      getParentFun: 'measure/getSafetyMeasureList',
      formParams: {
        orgUid: (params) => {
          return params.orgValue
        },
        orgName: (params) => {
          return params.orgName
        },
        measureType: '安全计量',
        measurePeriod: (params) => {
          const measure = params.state.measure.measureList[0]
          const measurePeriod =
            measure && measure.measure ? measure.measure.length + 1 : 1
          return measurePeriod
        }
      },
      formData: [
        {
          key: 'orgName',
          label: '所属项目标段',
          type: 'input',
          readonly: true,
          span: 18
        },
        {
          key: 'measureType',
          label: '计量类型',
          type: 'input',
          readonly: true,
          span: 18
        },
        {
          key: 'measurePeriod',
          label: '计量期数',
          type: 'input',
          readonly: true,
          span: 18
        }
      ]
    }
  },
  measureStatistics: {
    name: 'measureStatistics',
    componentTypes: ['navigate', 'check', 'tables'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    headButtons: (params) => {
      var headButtons
      if (
        params.orgBuildType === '总承包单位' &&
        (params.pageStatus === 6 ||
          params.pageStatus === 5 ||
          params.pageStatus === 0)
      ) {
        headButtons = setCheckButtons(['申报', '提交'])
      } else if (
        params.orgBuildType === '监理单位' &&
        (params.pageStatus === 4 || params.pageStatus === 3)
      ) {
        headButtons = setCheckButtons(['审核', '提交', '退回'])
      } else if (
        params.orgBuildType === '建设单位' &&
        params.pageStatus === 2
      ) {
        headButtons = setCheckButtons(['审核', '提交', '退回'])
      } else {
        headButtons = setCheckButtons(['明细'])
        //headButtons = setCheckButtons(['审核', '提交', '退回'])
      }
      return headButtons
    },
    getListFun: 'measure/getSafetyMeasureDetail',
    getParentFun: 'measure/getSafetyMeasureList',
    confirmFun: 'measure/confirmMeasure',
    detailPage: [
      {
        codes: ['add', 'approve', 'check'],
        type: 'tables',
        name: 'measureDetail',
        step: 'measureDetailList',
        theme: 'safetyInput',
        label: () => {
          return (params) => {
            return params.code === 'add'
              ? '安全计量明细申报'
              : params.code === 'approve'
              ? '安全计量明细审核'
              : '安全计量明细查看'
          }
        },
        pageStatus: (params) => {
          return params.pageStatus
        }
      },
      {
        buttonName: '提交',
        type: 'goBack'
      }
    ],
    tagInfo: '当前页面为当期次申报的计量明细按安全经费类型的统计汇总列表',
    tagImg: (params) => {
      var tagImg = ''
      if (params.pageStatus === 5 || params.pageStatus === 6) {
        tagImg = require('@/assets/img/declare.png')
      } else if (params.pageStatus === 0) {
        tagImg = require('@/assets/img/returned.png')
      } else if (params.pageStatus === 1) {
        tagImg = require('@/assets/img/approved.png')
      } else {
        tagImg = require('@/assets/img/examine.png')
      }
      return tagImg
    },
    rowData: (params) => {
      return params.getters['measure/safetyMeasureStatistics']
    },
    showSummary: true,
    columns: [
      {
        prop: 'securityFundType',
        label: '\xa0\xa0\xa0安全经费类型',
        width: '600px',
        bgcolor: true,
        align: 'left'
      },
      {
        prop: 'declaredAmount',
        label: '申报金额(元)',
        drillDown: true
      },
      {
        prop: 'amountReviewedByResident',
        label: '驻地办审核金额(元)',
        drillDown: true
      },
      {
        prop: 'amountReviewedByDirector',
        label: '总监办审核金额(元)',
        drillDown: true
      },
      {
        prop: 'amountReviewedByProject',
        label: '项目办（公司）审核金额(元)',
        drillDown: true
      }
    ]
  },
  measureDetail: {
    name: 'measureDetail',
    componentTypes: ['navigate', 'check', 'tables', 'drawerTable'],
    saveFun: (params) => {
      return params.pageStatus === 6 || params.pageStatus === 5
        ? 'measure/addSafetyMeasureDetail'
        : 'measure/editSafetyMeasureDetail'
    },
    //getParentFun: 'measure/getSafetyMeasureDetail',
    getListFun: 'measure/getSafetyMeasureDetail',
    deleteFun: 'measure/deleteSafetyMeasureDetail',
    expandColumn: true,
    detailPage: [
      {
        buttonName: '物资验收单编号',
        type: 'drawerTable',
        name: 'goodsInbound',
        checkType: 'checkByRow',
        checkFun: 'material/getGoodsList',
        pageStatus: 'check'
      },
      {
        buttonName: '保存',
        type: 'goBack'
      },
      {
        buttonName: '发票图片',
        type: 'preview'
      },
      {
        buttonName: '其他附件',
        type: 'preview'
      }
    ],
    headButtons: (params) => {
      return params.pageStatus !== 1 ? setCheckButtons(['保存']) : ''
    },
    tagInfo: (params) => {
      return params.pageStatus === 6 || params.pageStatus === 5
        ? '系统自动统计截止当前时间已核查且未全部计量的，同时物资采购类型时有采购明细的使用台帐，并默认填充其剩余未计量金额至申报金额，申报金额不应大于费用支出金额或现场投入金额减去已计量金额，超限错误数据会自动标红，可按实际情况修改。'
        : '申报金额不应大于剩余未计量金额和现场投入金额；各级审核金额不应大于前一流程上报或审核金额；超限错误数据会自动标红，请修正后提交'
    },
    showSummary: true,
    rowData: (params) => {
      return params.getters['measure/safetyMeasureDetail']
    },
    columns: (params) => {
      var isIdeal = () => {
        return (row, column) => {
          if (column.prop === 'declaredAmount' && row.investAmount) {
            return row.declaredAmount <= row.investAmount - row.measuredAmount
              ? true
              : false
          } else if (column.prop === 'declaredAmount' && !row.investAmount) {
            return row.declaredAmount <= row.expenseAmount - row.measuredAmount
              ? true
              : false
          } else if (column.prop === 'amountReviewedByResident') {
            return row.amountReviewedByResident <= row.declaredAmount
              ? true
              : false
          } else if (column.prop === 'amountReviewedByDirector') {
            return row.amountReviewedByDirector <= row.amountReviewedByResident
              ? true
              : false
          } else if (column.prop === 'amountReviewedByProject') {
            return row.amountReviewedByProject <= row.amountReviewedByDirector
              ? true
              : false
          }
        }
      }
      const columns = [
        {
          prop: 'account',
          label: '使用台帐及明细',
          width: '300px',
          formItem: {
            type: 'select',
            options: (params) => {
              const safetyUseAccount = JSON.parse(
                JSON.stringify(params.state.safetyInput.safetyUseAccount)
              )
              safetyUseAccount.filter((item) => {
                if (item.children) {
                  item.children = item.children.filter((child) => {
                    safetyUseAccount.push(child)
                  })
                }
                return (
                  item.checkStatus === '已核查' &&
                  item.measureState !== '全部计量' &&
                  (item.useType === '非物资采购' ||
                    (item.useType === '安全物资采购' && item.isHasInbound))
                )
              })
              safetyUseAccount.forEach((item) => {
                item.value = item.uid
                item.label = item.useDate
                  ? item.useDate + '\xa0' + item.useReason
                  : item.expenseName
              })
              return safetyUseAccount
            },
            placeholder: '请选择要核查使用台帐，展开可查看使用详情信息',
            valueKey: 'uid',
            //disabled: true,
            clearable: true
          }
        },
        { prop: 'measureState', label: '计量状态' },
        {
          prop: 'expenseAmount',
          label: '费用支出金额'
        },
        {
          prop: 'investAmount',
          label: '现场投入金额'
        },
        {
          prop: 'measuredAmount',
          label: '已计量金额'
        },
        {
          prop: 'declaredAmount',
          label: '申报金额',
          formItem: {
            type: 'input',
            readonly: (params) => {
              return params.pageStatus === 6 || params.pageStatus === 5
                ? false
                : true
            }
          },
          isIdeal: isIdeal
        },
        {
          prop: 'amountReviewedByResident',
          label: '驻地办审核',
          formItem: {
            type: 'input',
            readonly: (params) => {
              return params.pageStatus === 4 ? false : true
            },
            placeholder: (params) => {
              return params.pageStatus === 4 ? '请输入' : ''
            }
          },
          tooltip: {
            tipKey: 'opinionReviewedByResident',
            tipLabel: '审核意见：'
          },
          isIdeal: isIdeal
        },
        {
          prop: 'amountReviewedByDirector',
          label: '总监办审核',
          formItem: {
            type: 'input',
            readonly: (params) => {
              return params.pageStatus === 3 ? false : true
            },
            placeholder: (params) => {
              return params.pageStatus === 3 ? '请输入' : ''
            }
          },
          tooltip: {
            tipKey: 'opinionReviewedByDirector',
            tipLabel: '审核意见：'
          },
          isIdeal: isIdeal
        },
        {
          prop: 'amountReviewedByProject',
          label: '项目办审核',
          formItem: {
            type: 'input',
            readonly: (params) => {
              return params.pageStatus === 2 ? false : true
            },
            placeholder: (params) => {
              return params.pageStatus === 2 ? '请输入' : ''
            }
          },
          tooltip: {
            tipKey: 'opinionReviewedByProject',
            tipLabel: '审核意见：'
          },
          isIdeal: isIdeal
        }
      ]
      if (params.orgBuildType !== '总承包单位' && params.pageStatus !== 1) {
        columns.push({
          prop: 'opinion',
          label: '审核意见',
          formItem: {
            type: 'input',
            inputType: 'textarea',
            placeholder: '审核扣减金额后，建议留下审核意见'
          },
          width: '300px'
        })
      }
      return columns
    },
    goodsInbound: goodsInbound
  },
  safetyUse: {
    name: 'safetyUse',
    theme: '安全经费使用',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'drawerTable',
      'dialogForm',
      'dialogTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'safetyInput/getSafetyUseList',
    deleteFun: 'safetyInput/deleteSubitem',
    detailPage: [
      {
        buttonName: '计划编制',
        type: 'drawerTable',
        name: 'safetyUsePlan'
      },
      {
        buttonName: '使用台帐',
        type: 'tables',
        name: 'safetyUseAccount',
        step: 'safetyUseAccountList',
        theme: 'safetyInput',
        label: (params) => {
          return (
            (params.queryValues ? params.queryValues.year : '') +
            '年度安全经费使用台帐列表'
          )
        }
      },
      {
        buttonName: '使用核查',
        type: 'tables',
        name: 'safetyUseCheck',
        step: 'safetyUseCheckList',
        theme: 'safetyInput',
        label: (params) => {
          return (
            (params.queryValues ? params.queryValues.year : '') +
            '年度安全经费使用核查列表'
          )
        }
      },
      {
        codes: ['totolPlanAmount', 'planAmount', 'useAmount', 'deviation'],
        type: 'expand',
        name: 'safetyUse'
      }
    ],
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      year: new Date().getFullYear() + ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '项目标段名称',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'year',
        label: '使用年度',
        type: 'time',
        timetype: 'year',
        format: 'yyyy',
        clearable: false
      }
    ],
    headButtons: (params) => {
      return params.getters['user/orgBuildType'] === '总承包单位'
        ? setCheckButtons(['计划编制', '使用台帐', '使用核查'])
        : params.getters['user/orgBuildType'] === '监理单位'
        ? setCheckButtons(['计划审批'])
        : setCheckButtons(['计划台帐'])
    },
    tagInfo:
      '当前页面显示当前年度最新编制或调整后的安全资金使用计划，及其对应计划周期内的资金使用和使用核查情况；点击对应金额可展开查询下级明细',
    tagImg: (params) => {
      var tagImg = ''
      const currentPlan = params.state.safetyInput.currentPlan
      if (!currentPlan.approvalStatus) {
        tagImg = require('@/assets/img/unreport.png')
      } else if (currentPlan.approvalStatus === 0) {
        tagImg = require('@/assets/img/unreport.png')
      } else if (currentPlan.approvalStatus === 1) {
        tagImg = require('@/assets/img/unapproval.png')
      } else if (currentPlan.approvalStatus === 3) {
        tagImg = require('@/assets/img/approval.png')
      } else if (currentPlan.approvalStatus === 4) {
        tagImg = require('@/assets/img/refuse.png')
      }
      return tagImg
    },
    rowData: (params) => {
      return params.getters['safetyInput/safetyUseList']
    },
    showSummary: true,
    summaryMethod: () => {
      return ({ columns, data }) => {
        const sumKeys = {
          totolPlanAmount: true,
          planAmount: true,
          useAmount: true,
          deviation: true
        }
        return (columns || []).map((column, index) => {
          if (index === 0) return '合计'
          const prop = column && column.property
          if (!prop || !sumKeys[prop]) return ''
          const sum = getSameAttribute(data || [], prop).addValue
          return Math.round(Number(sum || 0) * 10000) / 10000
        })
      }
    },
    columns: [
      {
        prop: 'securityFundType',
        label: '\xa0\xa0安全经费类型',
        align: 'left',
        width: '600px',
        bgcolor: true
      },
      {
        prop: 'totolPlanAmount',
        label: '最新年度计划金额(万元)',
        drillDown: true
      },
      { prop: 'planAmount', label: '截止当前计划金额(万元)', drillDown: true },
      {
        prop: 'useAmount',
        label: '截止当前使用金额(万元)',
        drillDown: true
      },
      {
        prop: 'deviation',
        label: '截止当前使用节余(万元)',
        drillDown: true
      },
      {
        prop: 'useCheck',
        label: '系统自动核查分析',
        width: '460px',
        drillDown: true,
        isIdeal: '符合规定偏差范围'
      }
    ],
    hasPagination: false,
    safetyUsePlan: {
      name: 'safetyUsePlan',
      title: (params) => {
        return (
          params.state.queryValues.safetyUse.year + '年度安全经费使用计划列表'
        )
      },
      headButtons: (params) => {
        const cy = new Date().getFullYear()
        const y = new Date(
          params.state.queryValues.safetyUse.year
        ).getFullYear()
        return params.getters['user/orgBuildType'] === '总承包单位' && cy === y
          ? setCheckButtons(['新增'])
          : ''
      },
      getParentFun: 'safetyInput/getSafetyUseList',
      getListFun: 'safetyInput/getSafetyUsePlan',
      confirmFun: 'safetyInput/confirmSafetyUsePlan',
      deleteFun: 'safetyInput/deleteSafetyUsePlan',
      detailPage: [
        {
          codes: ['add', 'edit', 'check', 'approve'],
          type: 'tables',
          name: 'safetyUsePlan',
          checkType: 'useRowData',
          commitFun: 'safetyInput/setCurrentPlan',
          step: 'safetyUsePlanList',
          theme: 'safetyInput',
          label: (params) => {
            return (
              params.state.queryValues.safetyUse.year +
              '安全经费使用计划编制或调整'
            )
          }
        }
      ],
      rowData: (params) => {
        return params.state.safetyInput.safetyUsePlan
      },
      columns: [
        { prop: 'planName', label: '计划名称', width: '' },
        { prop: 'year', label: '计划年度', width: '' },
        {
          prop: 'planType',
          label: '计划类型',
          tag: [{ type: 'danger', label: '计划调整' }]
        },
        { prop: 'period', label: '调整期次' },
        {
          prop: 'status',
          label: '审批状态',
          tag: [
            { type: 'danger', label: '审批拒绝' },
            { type: 'success', label: '审批通过' },
            { type: 'warning', label: '待审批' }
          ]
        },
        { prop: 'approvalComments', label: '审批意见', width: '300px' },
        {
          label: '操作',
          buttons: (params) => {
            var buttonNames = []
            if (params.getters['user/orgBuildType'] === '总承包单位') {
              buttonNames = ['查看', '编制', '上报', '删除']
            } else if (params.getters['user/orgBuildType'] === '监理单位') {
              buttonNames = ['查看', '审批']
            } else if (params.pageStatus === '建设单位') {
              buttonNames = ['查看']
            }
            return setTableButtons(buttonNames)
          },
          width: '300px'
        }
      ]
    },
    deviations: deviations,
    violations: violations
  },
  safetyUsePlan: {
    name: 'safetyUsePlan',
    theme: '安全经费使用计划编制',
    componentTypes: ['navigate', 'check', 'tables', 'dialogForm'],
    getListFun: 'safetyInput/getSafetyUsePlan',
    confirmFun: 'safetyInput/confirmSafetyUsePlan',
    saveFun: (params) => {
      return params.pageStatus === 'add'
        ? 'safetyInput/addSafetyUsePlan'
        : 'safetyInput/editSafetyUsePlan'
    },
    deleteFun: 'safetyInput/deleteSafetyUsePlan',
    detailPage: [
      {
        codes: ['approve'],
        type: 'dialogForm',
        name: 'approvePlan'
      }
    ],
    headButtons: (params) => {
      var buttonNames = []
      if (params.pageStatus === 'add' || params.pageStatus === 'edit') {
        buttonNames = ['保存', '上报']
      } else if (params.pageStatus === 'check') {
        buttonNames = []
      } else if (params.pageStatus === 'approve') {
        buttonNames = ['审批']
      }
      return setCheckButtons(buttonNames)
    },
    border: true,
    showSummary: true,
    tagInfo: (params) => {
      const currentPlan = params.state.safetyInput.currentPlan
      const currentMonth = new Date().getMonth()
      return (
        '当前计划为' +
        params.state.currentStep.label +
        '；编制或调整周期为' +
        (!Object.keys(currentPlan).length
          ? '1月1日-12月31日'
          : (params.pageStatus === 'add' && currentPlan.approvalStatus === 3
              ? currentMonth + 1
              : currentPlan.adjustMonth + 1) + '月1日-12月31日') +
        '。新增或编辑时打开折叠行可填报数据，默认初始值为原计划值，对原计划调整的数据提交后标注为红色，鼠标移入可显示原计划金额。'
      )
    },
    tagType: 'danger',
    tagImg: (params) => {
      var tagImg = ''
      const currentPlan = params.state.safetyInput.currentPlan
      if (!currentPlan.approvalStatus) {
        tagImg = require('@/assets/img/unreport.png')
      } else if (currentPlan.approvalStatus === 0) {
        tagImg = require('@/assets/img/unreport.png')
      } else if (currentPlan.approvalStatus === 1) {
        tagImg = require('@/assets/img/unapproval.png')
      } else if (currentPlan.approvalStatus === 3) {
        tagImg =
          params.pageStatus === 'add'
            ? require('@/assets/img/unreport.png')
            : require('@/assets/img/approval.png')
      } else if (currentPlan.approvalStatus === 4) {
        tagImg = require('@/assets/img/refuse.png')
      }
      return tagImg
    },
    rowData: (params) => {
      return params.getters['safetyInput/compilePlan']
    },
    columns: (params) => {
      const currentPlan = params.state.safetyInput.currentPlan
      const currentMonth = new Date().getMonth()
      const adjustMonth = !Object.keys(currentPlan).length
        ? 0
        : params.pageStatus === 'add' && currentPlan.approvalStatus === 3
        ? currentMonth
        : currentPlan.adjustMonth
      var formItem = () => {
        return (row, column) => {
          var formItem =
            params.pageStatus !== 'check' &&
            params.pageStatus !== 'approve' &&
            parseInt(column.prop) >= adjustMonth
              ? {
                  type: 'input'
                }
              : null
          return formItem
        }
      }
      var tooltip = () => {
        return (row, column) => {
          var tooltip =
            parseInt(column.prop) >= adjustMonth || column.prop === 'totol'
              ? {
                  tipKey: 'original' + column.prop,
                  tipLabel: '原计划：'
                }
              : null
          return tooltip
        }
      }
      var isIdeal = () => {
        return (row, column) => {
          const tipKey = 'original' + column.prop
          return row[tipKey] === row[column.prop] ? true : false
        }
      }
      var columns = [
        {
          prop: 'securityFundType',
          label: '\xa0\xa0安全经费类型',
          align: 'left',
          width: '560px',
          bgcolor: true
        },
        {
          label: '计划或调整金额(万元)',
          children: [
            {
              prop: '0',
              label: '1月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '1',
              label: '2月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '2',
              label: '3月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '3',
              label: '4月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '4',
              label: '5月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '5',
              label: '6月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '6',
              label: '7月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '7',
              label: '8月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '8',
              label: '9月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '9',
              label: '10月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '10',
              label: '11月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: '11',
              label: '12月',
              formItem: formItem,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            },
            {
              prop: 'totol',
              label: '小计',
              bgcolor: true,
              tooltip: tooltip,
              unShow0: true,
              isIdeal: isIdeal
            }
          ]
        }
      ]
      return columns
    },
    hasPagination: false,
    approvePlan: {
      title: '安全资金使用计划审批',
      name: 'approvePlan',
      detailPage: [
        {
          buttonNames: ['审批'],
          type: 'goBack'
        }
      ],
      approveFun: 'safetyInput/approveSafetyUsePlan',
      getParentFun: 'safetyInput/getSafetyUsePlan',
      formParams: {
        uid: (params) => {
          return params.state.safetyInput.currentPlan.uid
        },
        approvalStatus: 3,
        approvalComments: ''
      },
      formRules: {
        approvalComments: [
          {
            required: (params) => {
              return params.formValues && params.formValues.approvalStatus === 4
            },
            message: '请输入审批意见',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'approvalStatus',
          label: '审批状态',
          type: 'select',
          options: [
            { value: 3, label: '审批通过' },
            { value: 4, label: '审批拒绝' }
          ],
          checkByValue: true,
          span: 18
        },
        {
          key: 'approvalComments',
          label: '审批意见',
          type: 'input',
          placeholder: '请留下审批意见或建议',
          span: 18
        }
      ]
    }
  },
  safetyUseAccount: {
    name: 'safetyUseAccount',
    theme: '安全经费使用登记',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogTable'
    ],
    addFun: 'safetyInput/addSafetyUseAccount',
    editFun: 'safetyInput/editSafetyUseAccount',
    getListFun: 'safetyInput/getSafetyUseAccount',
    deleteFun: 'safetyInput/deleteSafetyUseAccount',
    detailPage: [
      {
        buttonName: '新增',
        type: 'stepForm',
        name: 'safetyUseAccount',
        step: 'safetyUseAccountInfo',
        theme: 'safetyInput',
        label: '安全经费使用登记'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'safetyUseAccount',
        checkType: 'useRowData',
        step: 'safetyUseAccountInfo',
        theme: 'safetyInput',
        label: '安全经费使用登记'
      },
      {
        buttonName: '使用类型',
        type: (params) => {
          return params.currentRow && params.currentRow.checkReportUid
            ? 'drawerTable'
            : null
        },
        name: 'goodsInbound',
        checkType: 'checkByRow',
        checkFun: 'material/getGoodsList',
        pageStatus: 'check'
      },
      {
        buttonName: '使用明细',
        type: 'dialogTable',
        name: 'useDetails',
        checkType: 'useRowData',
        commitFun: 'safetyInput/setCurrentAccount'
      },
      {
        buttonName: '资金类型分配',
        type: 'dialogTable',
        name: 'useDetails'
      }
    ],
    headButtons: (params) => {
      const cy = new Date().getFullYear()
      const y = new Date(params.state.queryValues.safetyUse.year).getFullYear()
      return params.getters['user/orgBuildType'] === '总承包单位' && cy === y
        ? setCheckButtons(['新增'])
        : ''
    },
    tagInfo: (params) => {
      const account = params.state.safetyInput.safetyUseAccount
      const amount = getSameAttribute(account, 'useAmount').addValue
      return (
        '当前年度共计支付使用安全经费' +
        account.length +
        '笔，累计使用金额' +
        amount +
        '万元；点击物资采购类型或使用明细数据可跳转或下钻增删改查对应信息，当安全经费已关联计量数据时则不可修改使用明细数据。'
      )
    },
    rowData: (params) => {
      const safetyUseAccount = JSON.parse(
        JSON.stringify(params.state.safetyInput.safetyUseAccount)
      )
      safetyUseAccount.forEach((item) => {
        delete item.children
      })
      return safetyUseAccount
    },
    columns: [
      { prop: 'accountNum', label: '台帐编号', width: '160px' },
      { prop: 'useDate', label: '使用时间', width: '' },
      { prop: 'useReason', label: '使用缘由', width: '220px' },
      { prop: 'useAmount', label: '使用金额(元)', width: '' },
      { prop: 'useDepartment', label: '使用部门', width: '' },
      { prop: 'usePerson', label: '领用人' },
      { prop: 'approver', label: '审批人' },
      {
        prop: 'checkStatus',
        label: '核查及计量状态',
        width: '140px',
        tag: [{ type: 'success', label: '已核查' }]
      },
      {
        prop: 'useType',
        label: '使用类型',
        tooltip: { tipLabel: '物资验收单编号：', tipKey: 'checkReportNo' },
        tag: [{ type: 'danger', label: '非物资采购' }]
      },
      { prop: 'detailNum', label: '使用明细', drillDown: true },
      {
        prop: 'hasInvoice',
        label: '是否有发票',
        tag: (params) => {
          return params.dictionarys.isTrue
        }
      },
      {
        label: '操作',
        buttons: (params) => {
          return params.getters['user/orgBuildType'] === '总承包单位'
            ? setTableButtons(['编辑', '删除', '附件'])
            : setTableButtons(['查看', '附件'])
        },
        width: '220px'
      }
    ],
    formParams: (params) => {
      let goodsInbound = JSON.parse(
        JSON.stringify(params.state.material.goodsInbound)
      )
      let data = {
        uid: 'expenseName',
        label: 'expenseName',
        childUid: 'uid',
        childLabel: 'goods',
        sumKeys: ['inboundAmount'],
        keepKeys: ['securityFundType', 'expenseName']
      }
      goodsInbound = getLevelArray(goodsInbound, data)
      goodsInbound.forEach((item) => {
        item.expenseAmount = item.inboundAmount
        item.fundType = item.expenseName + '：\xa0' + item.inboundAmount + '元'
        delete item.children
      })
      var formParams =
        params.lastStep.step === 'safetyUseAccountList'
          ? {
              uid: '',
              accountNum: '',
              orgUid: (params) => {
                return params.orgValue
              },
              useDate: daysFormat(new Date()),
              useReason: '',
              useDepartment: '',
              usePerson: '',
              approver: '',
              useAmount: 0,
              useType: '非物资采购',
              fundType: '',
              supplier: '',
              useDetails: [],
              checkReportNo: '',
              checkStatus: '未核查',
              invoiceNo: '',
              invoiceAmount: '',
              invoiceImg: '',
              otherEnclosure: [],
              fileLists: {
                invoiceImg: [],
                otherEnclosure: []
              }
            }
          : params.pageStatus === 'add'
          ? {
              uid: params.state.material.goodsInbound[0].checkReportUid
                ? params.state.material.goodsInbound[0].checkReportUid
                : '',
              accountNum: params.state.material.goodsInbound[0].checkReportUid
                ? params.state.material.goodsInbound[0].accountNum
                : 'NO.' + getStringTime(new Date()),
              orgUid: (params) => {
                return params.orgValue
              },
              useDate: daysFormat(new Date()),
              useReason: '施工现场安全物资采购',
              useDepartment: '',
              usePerson: params.state.material.goodsInbound[0].checkPerson,
              approver: '',
              useAmount: getSameAttribute(
                params.state.material.goodsInbound,
                'inboundAmount'
              ).addValue,
              useType: '安全物资采购',
              fundType: getSameAttribute(goodsInbound, 'fundType', '；\n')
                .joinString,
              supplier: params.state.material.goodsInbound[0].supplier,
              useDetails: goodsInbound,
              checkReportNo: params.state.material.goodsInbound[0]
                .checkReportUid
                ? params.state.material.goodsInbound[0].checkReportNo
                : 'NO.' + getStringTime(new Date()),
              checkStatus: '未核查',
              invoiceNo: '',
              invoiceAmount: '',
              invoiceImg: '',
              otherEnclosure: [],
              fileLists: {
                invoiceImg: [],
                otherEnclosure: []
              }
            }
          : params.state.safetyInput.currentAccount
      return formParams
    },
    formRules: {
      useDate: [
        {
          required: true,
          message: '请选择使用时间',
          trigger: 'blur'
        }
      ],
      useReason: [
        {
          required: true,
          message: '请输入使用缘由',
          trigger: 'blur'
        }
      ],
      useDepartment: [
        {
          required: true,
          message: '请选择使用部门',
          trigger: 'blur'
        }
      ],
      usePerson: [
        {
          required: true,
          message: '请选择资金使用人或物资采购人',
          trigger: 'blur'
        }
      ],
      approver: [
        {
          required: true,
          message: '请选择审批人',
          trigger: 'blur'
        }
      ],
      useAmount: [
        {
          validator: (params) => {
            return params.validate.validateUseAmount
          },
          trigger: 'change'
        }
      ],
      useType: [
        {
          required: true,
          message: '请选择经费使用类型',
          trigger: 'blur'
        }
      ],
      fundType: [
        {
          validator: (params) => {
            return params.validate.validateFundType
          },
          trigger: 'change'
        }
      ],
      invoiceNo: [
        {
          validator: (params) => {
            return params.validate.validateInvoiceNo
          },
          trigger: 'change'
        }
      ],
      invoiceAmount: [
        {
          validator: (params) => {
            return params.validate.validateInvoiceAmount
          },
          trigger: 'change'
        }
      ],
      supplier: [
        {
          required: true,
          message: '请选择服务商或供货商',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: (params) => {
        return params.lastStep.step === 'safetyUseAccountList'
          ? '安全经费使用登记'
          : '安全物资验收单信息'
      },
      manualUpload: true,
      bottomButtons: getStepFormBottomButtons(3),
      fields: [
        {
          key: (params) => {
            return params.pageStatus === 'add' &&
              params.lastStep.step === 'safetyGoodsList'
              ? 'checkReport'
              : ''
          },
          label: '物资验收单',
          type: 'select',
          options: (params) => {
            const checkReport = params.state.material.checkReport.filter(
              (item) => {
                return item.useAmount === 0
              }
            )
            checkReport.forEach((item) => {
              item.value = item.uid
              item.label =
                item.checkReportNo +
                '\xa0' +
                item.useReason +
                item.useAmount +
                '元'
            })
            return checkReport
          },
          valueKey: 'uid',
          placeholder:
            '可选择还没有验收明细的验收单进行关联，不选则系统自动新增验收单',
          clearable: true
        },
        {
          key: 'useReason',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用缘由'
              : '采购缘由'
          },
          type: 'input',
          placeholder:
            '请输入使用缘由，指具体某业务事项支出，应与对应发票相匹配，如某批次物资采购验收'
        },
        {
          key: 'useDate',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用时间'
              : '验收时间'
          },
          type: 'time',
          placeholder: '请选择使用或入库时间'
        },
        {
          key: 'useType',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用类型'
              : '采购类型'
          },
          type: 'select',
          options: [
            { value: '0', label: '安全物资采购' },
            { value: '1', label: '非物资采购' }
          ],
          disabled: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? false
              : true
          }
        },
        {
          key: 'supplier',
          label: (params) => {
            return params.formValues &&
              params.formValues.useType === '安全物资采购'
              ? '供货商'
              : '服务商'
          },
          type: 'select',
          options: () => {
            return []
          },
          filterable: true,
          disabled: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? false
              : true
          },
          create: true
        },
        {
          key: 'useAmount',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用金额'
              : '采购金额'
          },
          type: 'input',
          placeholder: '请输入使用或采购金额',
          disabled: (params) => {
            return params.formValues &&
              params.formValues.useType !== '非物资采购'
              ? true
              : false
          },
          inputTip: (params) => {
            return params.formValues &&
              params.formValues.useType !== '非物资采购'
              ? '新增时默认为0元，需通过添加或编辑物资验收单明细改变金额'
              : ''
          },
          inputButton: '元',
          number: 2
        },
        {
          key: 'fundType',
          label: '资金类型明细',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          placeholder: '根据使用情况将使用金额按照资金类型分配，至少选择一项',
          readonly: true,
          check: (params) => {
            return !params.state.safetyInput.currentAccount.isMeasured
              ? '资金类型分配'
              : ''
          }
        },
        {
          key: 'useDepartment',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用部门'
              : '采购部门'
          },
          type: 'select',
          options: (params) => {
            return params.orgFields.department && params.orgFields.department[0]
              ? params.orgFields.department[0].children
              : []
          },
          filterable: true,
          create: true
        },
        {
          key: 'usePerson',
          label: (params) => {
            return params.lastStep.step === 'safetyUseAccountList'
              ? '使用人'
              : '采购人'
          },
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          placeholder: '请输入或选择资金使用人或物资采购员',
          filterable: true,
          create: true
        },
        {
          key: 'approver',
          label: '审批人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        },
        {
          key: 'invoiceNo',
          label: '发票编号',
          type: 'input',
          placeholder: '请输入发票编号，同一编号的发票只能录入一次'
        },
        {
          key: 'invoiceAmount',
          label: '发票金额',
          type: 'input',
          placeholder: '请输入发票金额',
          number: 2
        },
        {
          key: 'invoiceImg',
          label: '发票照片',
          type: 'upload',
          uploadtip: '点击上传“发票照片”',
          listType: 'text',
          fileType: 'backCard',
          showFilelist: false,
          autoUpload: false,
          srcList: true
        },
        {
          key: 'otherEnclosure',
          label: '其他附件',
          type: 'upload',
          autoUpload: false,
          limit: 4
        }
      ]
    },
    useDetails: useDetails,
    goodsInbound: goodsInbound
  },
  safetyUseCheck: {
    name: 'safetyUseCheck',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'dialogTable',
      'drawerTable'
    ],
    addFun: 'safetyInput/addSafetyUseCheck',
    editFun: 'safetyInput/editSafetyUseCheck',
    //getParentFun: 'safetyInput/getSafetyUseList',
    getListFun: 'safetyInput/getSafetyUseCheck',
    deleteFun: 'safetyInput/deleteSafetyUseCheck',
    confirmFun: 'safetyInput/confirmSafetyUseCheck',
    detailPage: [
      {
        code: 'add',
        type: 'stepForm',
        name: 'safetyUseCheck',
        step: 'safetyUseCheckInfo',
        theme: 'safetyInput',
        label: '安全经费使用核查'
      },
      {
        code: 'edit',
        type: 'stepForm',
        name: 'safetyUseCheck',
        checkType: 'useRowData',
        step: 'safetyUseCheckInfo',
        theme: 'safetyInput',
        label: '安全经费使用核查'
      },
      {
        codes: ['deviations'],
        type: 'dialogTable',
        name: 'deviations',
        checkType: 'useRowData',
        pageStatus: (params) => {
          return params.currentRow &&
            params.currentRow.confirmStatus === '已确认'
            ? 'check'
            : params.currentRow &&
              params.currentRow.checkDetails &&
              params.currentRow.checkDetails.length
            ? 'edit'
            : 'add'
        },
        commitFun: 'safetyInput/setDeviations'
      },
      {
        codes: ['violations'],
        type: 'dialogTable',
        name: 'violations',
        checkType: 'useRowData',
        pageStatus: (params) => {
          return params.currentRow &&
            params.currentRow.confirmStatus === '已确认'
            ? 'check'
            : params.currentRow &&
              params.currentRow.violationDetails &&
              params.currentRow.violationDetails.length
            ? 'edit'
            : 'add'
        },
        commitFun: 'safetyInput/setViolations'
      },
      {
        buttonName: '使用偏差分析',
        type: 'dialogTable',
        name: 'deviations'
      },
      {
        buttonName: '违规核查登记',
        type: 'dialogTable',
        name: 'violations'
      }
    ],
    headButtons: (params) => {
      const cy = new Date().getFullYear()
      const y = new Date(params.state.queryValues.safetyUse.year).getFullYear()
      return params.getters['user/orgBuildType'] === '总承包单位' &&
        cy === y &&
        params.state.queryValues.safetyUse.projectUid === params.orgValue
        ? setCheckButtons(['新增'])
        : ''
    },
    tagInfo: (params) => {
      const account = params.state.safetyInput.safetyUseCheck
      const deviation = getSameAttribute(
        params.getters['safetyInput/safetyUseList'],
        'deviation'
      ).addValue
      const violations = params.state.safetyInput.violations
      const isCorrect = violations.filter((item) => {
        return !item.isCorrect
      })
      return (
        '当前年度共计安全经费核查' +
        account.length +
        '次。截止当前与计划相比累计节余安全经费' +
        deviation.toFixed(4) +
        '万元；累计发现违规项支出' +
        violations.length +
        '笔，其中' +
        isCorrect.length +
        '项未整改。'
      )
    },
    rowData: (params) => {
      return params.state.safetyInput.safetyUseCheck
    },
    columns: [
      { prop: 'checkName', label: '核查名称', width: '240px' },
      { prop: 'period', label: '核查期次', width: '100px' },
      {
        prop: 'checkDate',
        label: '核查日期',
        width: '120px'
      },
      {
        prop: 'endMonth',
        label: '数据截止日期',
        width: '120px'
      },
      {
        prop: 'personInCharge',
        label: '核查负责人',
        tooltip: {
          tipKey: 'allPerson',
          tipLabel: '所有参与人员：'
        },
        width: '100px'
      },
      {
        prop: 'confirmStatus',
        label: '确认状态',
        tag: [
          { type: 'success', label: '已确认' },
          { type: 'danger', label: '未确认' }
        ],
        width: '110px'
      },
      {
        prop: 'deviations',
        label: '使用偏差情况',
        drillDown: true,
        width: '130px'
      },
      {
        prop: 'violations',
        label: '使用违规情况',
        drillDown: true,
        width: '200px'
      },
      { prop: 'checkOpinion', label: '核查意见' },
      {
        label: '操作',
        buttons: (params) => {
          var buttonNames = []
          if (params.getters['user/orgBuildType'] === '总承包单位') {
            buttonNames = ['编辑', '确认', '删除']
          } else {
            buttonNames = ['查看']
          }
          return setTableButtons(buttonNames)
        },
        width: '220px'
      }
    ],
    formParams: (params) => {
      var formParams = {}
      const year = params.state.queryValues.safetyUse.year
      const period = params.state.safetyInput.safetyUseCheck.length + 1
      formParams.uid = ''
      formParams.checkName = year + '年度第' + period + '次安全经费使用核查'
      formParams.orgUid = params.orgValue
      formParams.year = year
      formParams.checkPeriod = period
      formParams.endMonth = daysFormat(new Date())
      formParams.confirmStatus = '未确认'
      formParams.checkDate = daysFormat(new Date())
      formParams.personInCharge = ''
      formParams.participants = []
      formParams.checkDetails = []
      formParams.violationDetails = []
      formParams.checkOpinion = ''
      return formParams
    },
    formRules: {
      checkName: [
        {
          required: true,
          message: '请输入核查名称',
          trigger: 'blur'
        }
      ],
      endMonth: [
        {
          validator: (params) => {
            return params.validate.validateEndMonth
          },
          trigger: 'change'
        }
      ],
      checkDate: [
        {
          required: true,
          message: '请选择核查日期',
          trigger: 'change'
        }
      ],
      personInCharge: [
        {
          required: true,
          message: '请选择核查负责人',
          trigger: 'blur'
        }
      ],
      participants: [
        {
          type: 'array',
          required: true,
          message: '请至少选择一个核查参与人员',
          trigger: 'change'
        }
      ],
      useType: [
        {
          required: true,
          message: '请选择经费使用类型',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '安全经费使用核查',
      bottomButtons: getStepFormBottomButtons(3),
      fields: [
        {
          key: 'checkName',
          label: '核查名称',
          type: 'input'
        },
        {
          key: 'endMonth',
          label: '数据截止日期',
          type: 'time',
          disabled: (params) => {
            return params.pageStatus === 'edit' ? true : false
          }
        },
        {
          key: 'checkDate',
          label: '核查日期',
          type: 'time'
        },
        {
          key: 'personInCharge',
          label: '核查负责人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        },
        {
          key: 'participants',
          label: '参与核查人员',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          multiple: true,
          filterable: true,
          create: true
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'deviations' : ''
          },
          label: '使用偏差情况',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          placeholder: '根据使用情况分析资金使用与计划的偏差',
          readonly: true,
          check: '使用偏差分析'
        },
        {
          key: (params) => {
            return params.pageStatus === 'add' ? 'violations' : ''
          },
          label: '使用违规情况',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          placeholder: '根据使用情况核查资金使用是否有违规',
          readonly: true,
          check: '违规核查登记'
        },
        {
          key: 'checkOpinion',
          label: '核查意见',
          type: 'input'
        }
      ]
    },
    goodsInbound: goodsInbound,
    deviations: deviations,
    violations: violations
  },
  safetyGoods: {
    name: 'safetyGoods',
    theme: '安全物资出入库列表',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'drawerTable',
      'dialogForm',
      'dialogTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    headButtons: (params) => {
      return params.getters['user/orgBuildType'] === '总承包单位'
        ? setCheckButtons([
            '入库登记',
            '生成验收单',
            '生成领用单',
            '验收单管理',
            '领用单管理'
          ])
        : setCheckButtons(['验收单管理', '领用单管理'])
    },
    getListFun: 'material/getGoodsList',
    deleteFun: 'material/deleteGoodsInbound',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      goodsType: '安全物资',
      supplier: '',
      inboundDate: [],
      checkReportUid: '',
      query: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'goodsType',
        label: '物资类型',
        type: 'cascader',
        options: (params) => {
          const goodsType = params.state.dictionarys.goodsType
            ? params.state.dictionarys.goodsType.filter((item) => {
                return item.label === '安全物资'
              })
            : []
          return goodsType
        },
        placeholder: '可任选一个级别选项',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        emitPath: false
      },
      {
        key: 'supplier',
        label: '供应商',
        type: 'select',
        options: (params) => {
          return params.state.contractor.supplier
        },
        filterable: true,
        create: true
      },
      {
        key: 'hasCheckReport',
        label: '是否有验收单',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trueFalse
        }
      },
      {
        key: 'inboundDate',
        label: '入库时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '物资编号/物资名称/规格型号'
      }
    ],
    detailPage: [
      {
        buttonName: '入库登记',
        type: 'tables',
        name: 'goodsInbound',
        step: 'goodsInboundList',
        theme: 'safetyInput',
        label: '安全物资入库登记列表'
      },
      {
        buttonName: '生成领用单',
        type: 'drawerTable',
        name: 'goodsOutbound',
        expandAll: true
      },
      {
        buttonName: '生成验收单',
        type: 'drawerTable',
        name: 'goodsInbound'
      },
      {
        buttonName: '验收单管理',
        type: 'tables',
        name: 'checkReports',
        theme: 'safetyInput',
        step: 'checkReportsList',
        label: '安全物资验收单列表',
        checkType: 'checkByQuery',
        checkFun: 'material/getCheckReport'
      },
      {
        buttonName: '领用单管理',
        type: 'tables',
        name: 'useReports',
        theme: 'safetyInput',
        step: 'useReportsList',
        label: '安全物资领用单列表',
        checkType: 'checkByQuery',
        checkFun: 'material/getUseReport',
        expandAll: true
      },
      {
        codes: ['checkQuantity', 'inboundQuantity', 'checkStatus'],
        name: () => {
          return (params) => {
            return params.row && params.row.checkInfo
              ? 'inboundCheck'
              : 'safetyGoods'
          }
        },
        type: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'stepForm' : 'expand'
          }
        },
        pageStatus: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'edit' : ''
          }
        },
        checkType: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'useRowData' : ''
          }
        },
        step: 'inboundCheckInfo',
        theme: 'safetyInput',
        label: '编辑物资验收明细'
      },
      {
        code: 'checkReportNo',
        type: () => {
          return (params) => {
            return params.row && params.row.checkInfo ? 'drawerTable' : 'expand'
          }
        },
        name: () => {
          return (params) => {
            return params.row && params.row.checkInfo
              ? 'goodsInbound'
              : 'safetyGoods'
          }
        },
        checkType: 'checkByRow',
        checkFun: 'material/getGoodsList',
        pageStatus: 'check'
      }
    ],
    selectColumn: true,
    tagInfo:
      '点击验收数量可编辑验收单明细；点击出库数量可编辑领用单明细；勾选同一供应商验收合格的入库物资明细后点击“生成验收单”可生成物资验收单或关联已有验收单；勾选已生成验收单的入库明细后点击“生成领用单”可生成物资领用单',
    rowData: (params) => {
      return params.getters['material/goodsLevelList']
    },
    columns: [
      {
        width: '300px',
        align: 'left',
        prop: 'label',
        label: '物资编号/名称&&供应商名称&&入库日期'
      },
      {
        prop: 'goodsTypes',
        label: '物资类型&&规格型号'
      },
      { width: '', prop: 'unit', label: '单位' },
      { width: '', prop: 'price', label: '单价' },
      {
        width: '',
        drillDown: true,
        prop: 'checkQuantity',
        label: '验收数量',
        tooltip: {
          tipKey: 'checkInfo'
        }
      },
      {
        width: '',
        drillDown: true,
        prop: 'unqualified',
        label: '不合格数量'
      },
      {
        width: '',
        drillDown: true,
        prop: 'inboundQuantity',
        label: '入库数量'
      },
      {
        width: '200px',
        prop: 'checkStatus',
        label: '验收情况',
        drillDown: true,
        isIdeal: () => {
          return (row) => {
            return (row.checkResult && row.checkResult !== '1') ||
              row.checkStatus === '0条待试验抽检'
              ? true
              : false
          }
        }
      },
      {
        width: '200px',
        prop: 'checkReportNo',
        label: '验收单编号',
        drillDown: true,
        isIdeal: () => {
          return (row) => {
            return row.checkReportUid || row.checkReportNo === '0条待生成'
              ? true
              : false
          }
        }
      },
      { width: '', drillDown: true, prop: 'totalUsed', label: '出库数量' },
      {
        width: '',
        drillDown: true,
        prop: 'theoreticalInventory',
        label: '理论库存'
      },
      {
        label: '操作',
        buttons: setTableButtons(['删除'])
      }
    ],
    goodsInbound: goodsInbound,
    goodsOutbound: goodsOutbound,
    useReport: useReport
  },
  goodsInbound: {
    name: 'goodsInbound',
    title: '安全物资入库登记列表',
    componentTypes: ['navigate', 'check', 'tables'],
    checkType: 'add',
    saveFun: (params) => {
      return params.pageStatus === 'add'
        ? 'material/addGoodsInbound'
        : 'material/editGoodsInbound'
    },
    getParentFun: 'material/getGoodsList',
    detailPage: [
      {
        buttonName: '生成验收单',
        name: 'safetyUseAccount',
        type: 'stepForm',
        checkType: 'useRowData',
        step: 'safetyUseAccountInfo',
        theme: 'safetyInput',
        label: '生成物资验收单'
      },
      {
        buttonName: '编辑',
        name: 'inboundCheck',
        type: 'stepForm',
        checkType: 'useRowData',
        step: 'inboundCheckInfo',
        theme: 'safetyInput',
        label: '编辑物资验收明细'
      }
    ],
    headButtons: (params) => {
      return params.pageStatus === 'add'
        ? setCheckButtons(['保存', '导入明细'])
        : setCheckButtons(['保存'])
    },
    queryParams: (params) => {
      var queryParams =
        params.pageStatus === 'add'
          ? {
              orgUid: params.orgValue,
              checkResult: '0',
              inboundDate: daysFormat(new Date()),
              checkDate: daysFormat(new Date()),
              unqualified: 0
            }
          : null
      return queryParams
    },
    selectData: (params) => {
      var selectData =
        params.pageStatus === 'add'
          ? [
              {
                key: 'goods',
                label: '物资名称规格',
                type: 'select',
                options: params.state.material.goods,
                filterable: true,
                multiple: true,
                placeholder:
                  '请批量选择要登记入库的物资名称及规格型号；如没有可手动输入添加，物资名称及规格型号用“/”分开；选择物资后添加前可展开选项录入共性信息',
                checkByValue: true,
                create: true,
                span: 24
              },
              {
                key: 'goodsType',
                label: '物资类型',
                type: 'cascader',
                options: (params) => {
                  const goodsType = params.state.dictionarys.goodsType.filter(
                    (item) => {
                      return item.label === '安全物资'
                    }
                  )
                  return goodsType
                },
                filterable: true
              },
              {
                key: 'checkPerson',
                label: '验收人',
                type: 'select',
                options: params.state.contractor.managePersonNames,
                filterable: true,
                create: true
              },
              {
                key: 'supplier',
                label: '供货商',
                type: 'select',
                options: params.state.contractor.supplier,
                filterable: true,
                create: true
              },
              {
                key: 'storageWarehouse',
                label: '存储仓库',
                type: 'input'
              }
            ]
          : null
      return selectData
    },
    tagInfo: (params) => {
      return params.pageStatus === 'add'
        ? '请批量导入入库明细或通过在表头表单中批量选择物资名称，并选择录入共性的入库信息，然后点击“添加”按钮多次批量生成入库清单，在列表中修改个性指标后保存，表头名称中加“*”的为必填。'
        : '当前列表明细已入库成功，修改列表数据点击“保存”按钮可批量编辑入库信息；点击行“编辑”按钮可单条编辑更多入库信息。'
    },
    rowData: (params) => {
      return params.state.material.goodsInbound
    },
    columns: [
      {
        prop: 'goods',
        label: '*物资编号/名称',
        width: '240px',
        formItem: (params) => {
          return params.pageStatus === 'add'
            ? {
                type: 'select',
                options: params.state.material.goods,
                filterable: true,
                checkByValue: true,
                create: true
              }
            : null
        }
      },
      {
        prop: 'model',
        label: '规格型号',
        formItem: {
          type: 'input'
        }
      },
      {
        prop: 'goodsType',
        label: '*物资类型',
        formItem: {
          type: 'cascader',
          options: (params) => {
            const goodsType = params.state.dictionarys.goodsType.filter(
              (item) => {
                return item.label === '安全物资'
              }
            )
            return goodsType
          },
          filterable: true,
          showAllLevels: false
        }
      },
      {
        prop: 'supplier',
        label: '*供货商',
        width: '200px',
        formItem: {
          type: 'select',
          options: () => {
            return []
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'unit',
        label: '*单位',
        width: '100px',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.dictionarys.unit
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'price',
        label: '单价(元)',
        width: '100px',
        formItem: {
          type: 'input'
        },
        number: 2
      },
      {
        prop: 'checkQuantity',
        label: '*验收数量',
        formItem: {
          type: 'input'
        },
        number: true
      },
      {
        prop: 'checkPerson',
        label: '*现场验收人',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        }
      },
      {
        prop: 'checkResult',
        label: '验收结果',
        width: '220px',
        formItem: {
          type: 'select',
          options: (params) => {
            return params.dictionarys.checkResult
          },
          checkByValue: true
        }
      },
      {
        prop: 'storageWarehouse',
        label: '*储存仓库',
        width: '160px',
        formItem: {
          type: 'input'
        }
      },
      {
        label: '操作',
        buttons: (params) => {
          return params.pageStatus === 'add'
            ? setTableButtons(['删除'])
            : setTableButtons(['编辑'])
        },
        width: '100px'
      }
    ],
    hasPagination: false
  },
  inboundCheck: {
    name: 'inboundCheck',
    componentTypes: ['navigate', 'stepForm', 'dialogTable'],
    editArray: true,
    manualUpload: true,
    editFun: 'material/editGoodsInbound',
    getParentFun: 'material/getGoodsList',
    formParams: {
      uid: '',
      model: '',
      unit: '',
      price: '',
      goodsType: [],
      checkQuantity: 0,
      checkResult: '0',
      unqualified: 0,
      inboundQuantity: 0,
      storageWarehouse: '',
      checkDate: '',
      checkPerson: '',
      checkContent: [],
      fileLists: {
        checkContent: []
      }
    },
    formRules: {
      goodsType: [
        {
          required: true,
          message: '请选择物资类型',
          trigger: 'change'
        }
      ],
      unit: [
        {
          required: true,
          message: '请输入或选择单位',
          trigger: 'change'
        }
      ],
      checkQuantity: [
        {
          required: (params) => {
            return params.formValues && !params.formValues.checkQuantity
          },
          message: '请输入不为0的验收数量'
        }
      ],
      checkPerson: [
        {
          required: true,
          message: '请输入或选择验收人员',
          trigger: 'change'
        }
      ],
      checkResult: [
        {
          required: true,
          message: '请选择验收结果',
          trigger: 'change'
        }
      ],
      unqualified: [
        {
          required: (params) => {
            return params.formValues && params.formValues.checkResult === '2'
          },
          message: '验收结果有不合格品时，必须输入不合格品数量',
          trigger: 'blur'
        }
      ],
      storageWarehouse: [
        {
          required: true,
          message: '验收结果有不合格品时，必须输入不合格品数量',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '安全物资入库验收明细',
      manualUpload: true,
      bottomButtons: getStepFormBottomButtons(3),
      fields: [
        {
          key: 'goods',
          label: '物资编号/名称',
          type: 'input',
          disabled: true
        },
        {
          key: 'model',
          label: '规格型号',
          type: 'input'
        },
        {
          key: 'goodsType',
          label: '物资类型',
          type: 'cascader',
          options: (params) => {
            return params.state.dictionarys.goodsType
              ? params.state.dictionarys.goodsType.filter((item) => {
                  return item.label === '安全物资'
                })
              : []
          },
          filterable: true
        },
        {
          key: 'supplier',
          label: '供货商',
          type: 'input',
          disabled: true
        },
        {
          key: 'unit',
          label: '单位',
          type: 'select',
          options: (params) => {
            return params.dictionarys.unit
          },
          filterable: true,
          create: true
        },
        {
          key: 'price',
          label: '单价(元)',
          type: 'input',
          number: 2
        },
        {
          key: 'checkQuantity',
          label: '验收数量',
          type: 'input',
          number: true
        },
        {
          key: 'unqualified',
          label: '不合格品数量',
          type: 'input',
          number: true
        },
        {
          key: 'inboundQuantity',
          label: '入库数量',
          type: 'input',
          disabled: true
        },
        {
          key: 'storageWarehouse',
          label: '储存仓库',
          type: 'input'
        },
        {
          key: 'inboundDate',
          label: '入库时间',
          type: 'time',
          disabled: true
        },
        {
          key: 'checkDate',
          label: '验收时间',
          type: 'time'
        },
        {
          key: 'checkPerson',
          label: '现场验收人',
          type: 'select',
          options: (params) => {
            return params.state.contractor.managePersonNames
          },
          filterable: true,
          create: true
        },
        {
          key: 'checkResult',
          label: '验收结果',
          type: 'select',
          options: (params) => {
            return params.dictionarys.checkResult
          },
          checkByValue: true
        },
        {
          key: 'checkContent',
          label: '验收附件',
          type: 'upload',
          autoUpload: false,
          limit: 4,
          span: 24
        }
      ]
    }
  },
  checkReports: {
    name: 'checkReports',
    theme: '安全物资入库单列表',
    componentTypes: ['navigate', 'check', 'tables', 'drawerTable', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'material/getCheckReport',
    deleteFun: 'material/deleteCheckReport',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      hasInvoice: '',
      checkStartDate: '',
      query: '',
      checkEndDate: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'checkDate',
        label: '验收时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'hasInvoice',
        label: '是否有发票',
        type: 'select',
        options: (params) => {
          return params.dictionarys.trueFalse
        }
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '采购人/采购部门/验收单编号'
      }
    ],
    detailPage: [
      {
        buttonName: '明细',
        type: 'drawerTable',
        name: 'goodsInbound',
        checkType: 'checkByRow',
        checkFun: 'material/getGoodsList',
        pageStatus: (params) => {
          return params.state.safetyInput.currentAccount.isMeasured
            ? 'check'
            : 'edit'
        }
      },
      {
        buttonNames: ['编辑', '查看'],
        type: 'stepForm',
        name: 'safetyUseAccount',
        checkType: 'useRowData',
        step: 'safetyUseAccountInfo',
        theme: 'safetyInput',
        label: '安全经费使用登记'
      }
    ],
    tagInfo:
      '当前列表为安全物资采购验收统计列表，当安全经费计量状态为未计量时可通过“明细”按钮查看和更新入库验收明细，其他计量状态不可更改明细数据',
    rowData: (params) => {
      return params.state.material.checkReport
    },
    columns: [
      { prop: 'checkReportNo', label: '验收单编号', width: '200px' },
      { prop: 'useReason', label: '采购缘由', width: '220px' },
      { prop: 'useDate', label: '验收时间', width: '' },
      { prop: 'useAmount', label: '采购金额(元)', width: '' },
      { prop: 'useDepartment', label: '采购部门', width: '' },
      { prop: 'usePerson', label: '采购人' },
      { prop: 'approver', label: '审批人' },
      {
        prop: 'useType',
        label: '使用类型',
        tag: [{ type: 'danger', label: '非物资采购' }]
      },
      {
        prop: 'hasInvoice',
        label: '是否有发票',
        tag: (params) => {
          return params.dictionarys.isTrue
        }
      },
      {
        prop: 'measureState',
        label: '计量状态',
        tag: [{ type: 'success', label: '未计量' }]
      },
      {
        label: '操作',
        buttons: (params) => {
          return params.getters['user/orgBuildType'] === '总承包单位'
            ? setTableButtons(['编辑', '明细', '删除', '附件'])
            : setTableButtons(['查看', '明细', '附件'])
        },
        width: '280px'
      }
    ],
    goodsInbound: goodsInbound
  },
  useReports: {
    name: 'useReports',
    theme: '安全物资领用单列表',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'drawerTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'material/getUseReport',
    deleteFun: 'material/deleteUseReport',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      projectUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      useStartDate: '',
      usePosition: '',
      query: '',
      useEndDate: ''
    },
    selectData: [
      {
        key: 'projectUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'usePosition',
        label: '使用部位',
        type: 'cascader',
        options: (params) => {
          return params.state.division.subitemList
        },
        placeholder: '可任选一个级别选项',
        filterable: true,
        checkStrictly: true,
        showAllLevels: false,
        emitPath: false
      },
      {
        key: 'useDate',
        label: '领用时间',
        type: 'time',
        timetype: 'daterange'
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '领用人/发放人/领用部门/使用部位'
      }
    ],
    detailPage: [
      {
        codes: ['edit', 'check'],
        type: 'drawerTable',
        name: 'goodsOutbound',
        checkType: 'checkByUid',
        checkFun: 'material/getGoodsOutbound',
        expandAll: true
      }
    ],
    rowData: (params) => {
      return params.state.material.useReport
    },
    columns: [
      {
        width: '',
        prop: 'useReportNo',
        label: '物资领用单编号'
      },
      {
        prop: 'useDate',
        label: '领用日期'
      },
      { width: '', prop: 'usePerson', label: '领用人' },
      { width: '', prop: 'grantPerson', label: '发放人' },
      {
        width: '460px',
        prop: 'usePosition',
        label: '使用部位'
      },
      {
        width: '',
        prop: 'useDepartment',
        label: '领用部门'
      },
      {
        width: '',
        prop: 'useAmount',
        label: '出库金额(元)'
      },
      {
        label: '操作',
        width: '220px',
        buttons: (params) => {
          return params.getters['user/orgBuildType'] === '总承包单位'
            ? setTableButtons(['编辑', '删除', '附件'])
            : setCheckButtons(['明细', '附件'])
        }
      }
    ],
    goodsOutbound: goodsOutbound,
    useReport: useReport
  }
}

export default safetyInput
